import { render, staticRenderFns } from "./GluingServices.vue?vue&type=template&id=50fcf763&scoped=true"
import script from "./GluingServices.vue?vue&type=script&lang=js"
export * from "./GluingServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fcf763",
  null
  
)

export default component.exports